export const thead = ['Referencial da Ronda', 'Egresso(s)', 'Data', "Status", 'Ações'];
export const headWidth = ["80%", "50%", "50%", "50%", "50%"];
